<template>
  <div v-if="authenticated" class="Home pt-2">
    <div class="Home__diverse mx-3">
      <diverse-slider data-v-step="1"></diverse-slider>
    </div>

    <hyrox-reservation v-if="false" class="mx-3 mt-3"></hyrox-reservation>
    <license-plate-popup ref="licensePopup" :user="user"></license-plate-popup>
    <!--
    <div v-if="showParty" class="mx-3 mt-3 mb-4 party-banner-wrapper" @click="$router.push('/party')">
      <div class="party-banner elevation-4">
        <div class="banner-bg"></div>
        <div class="glitter-overlay"></div>
        
        <div class="banner-content d-flex align-center justify-space-between pa-4">
          <div class="d-flex align-center">
            <div class="icon-circle-party mr-4">
              <v-icon color="white" large>mdi-party-popper</v-icon>
            </div>
            <div>
              <h3 class="text-h6 font-weight-black green--text text--accent-3 mb-0" style="line-height: 1.2">WELL COME FIT PARTY</h3>
              <div class="white--text caption font-weight-bold">Jetzt anmelden & feiern!</div>
            </div>
          </div>
          <v-btn icon dark small>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="status-stripe-party"></div>
      </div>
    </div>
    -->
    <!--
    <towel-reservation></towel-reservation>
    -->

    <chat-home-teaser></chat-home-teaser>

    <div class="Home__membership mx-3 mt-3 mb-3">
      <!-- Switch for Employees -->
      <div
        v-if="
          userService.hasRight('tt_employeeManage') &&
          !isStudioAccount &&
          !(
            userService.getEmail() === 'sebs@wellcomefit.ch' ||
            userService.getEmail() === 'dominic.ammann.ch@gmail.com' ||
            userService.getEmail() === 'tk@wellcomefit.ch'
          )
        "
        class="text-right mb-1">
        <v-btn x-small text color="grey" @click="showEmployeeCard = !showEmployeeCard">
          {{ showEmployeeCard ? "Zum Abo" : "Zur Zeiterfassung" }}
          <v-icon right x-small>{{ showEmployeeCard ? "mdi-card-account-details" : "mdi-clock" }}</v-icon>
        </v-btn>
      </div>

      <mini-stats-dashboard
        v-if="
          userService.getEmail() === 'sebs@wellcomefit.ch' ||
          userService.getEmail() === 'dominic.ammann.ch@gmail.com' ||
          userService.getEmail() === 'tk@wellcomefit.ch'
        "></mini-stats-dashboard>

      <employee-card v-else-if="userService.hasRight('tt_employeeManage') && showEmployeeCard && !isStudioAccount" :user="user"></employee-card>

      <active-contract-card
        v-if="!userService.hasRight('tt_employeeManage') || !showEmployeeCard"
        :user="user"
        @contracts-loaded="hasActiveContracts = true"
        @no-contracts="hasActiveContracts = false"
        @upgrade="openContractUpgrade"
        @quick-upgrade="handleQuickUpgrade"
        @timestop="openTimestop"
        @healthcare="openHealthcare"></active-contract-card>

      <div v-if="hasActiveContracts === false" class="mt-3">
        <membercard
          v-if="hasValidMembercard"
          :membercard="user.membercard"
          :firstName="user.vorname"
          :lastName="user.nachname"
          :email="user.email"
          @hideTraining="hideMyTraining = true"></membercard>

        <v-card
          v-else
          class="rounded-xl pa-5 d-flex flex-column align-center justify-center text-center orange darken-3 white--text"
          elevation="5"
          @click="showNoContractInfo = true"
          v-ripple>
          <v-icon size="40" color="white" class="mb-2">mdi-help-circle-outline</v-icon>
          <div class="font-weight-bold text-h6">Keine Mitgliedschaft?</div>
          <div class="caption opacity-90 mb-3">Wir konnten kein aktives Abo finden.</div>
          <v-btn rounded small color="white" class="orange--text text--darken-3 font-weight-bold px-4"> Ich habe aber ein Abo! </v-btn>
        </v-card>
      </div>
    </div>

    <div>
      <payment-home @foundOpenPayments="openPayments = true"></payment-home>
    </div>

    <div v-if="!alibeyStudio && !hideMyTraining" class="Home__training mx-3">
      <my-training data-v-step="0"></my-training>
    </div>

    <router-view></router-view>

    <div class="Home__groupFitness pb-5 mb-16 mx-3 mt-3">
      <training-zone data-v-step="2"></training-zone>
    </div>

    <alibey-popup></alibey-popup>
    <black-week-teaser></black-week-teaser>

    <upgrade-contract
      :useCustomer="true"
      :dialog="showContractDialog"
      :preloaded-possibilities="preloadedPossibilities"
      :initial-selected-package="initialSelectedPackage"
      @hide="closeContractDialog"
      @created="upgradeCreated()"></upgrade-contract>

    <v-dialog style="z-index: 9999" v-model="timestopActive" persistent fullscreen transition="dialog-bottom-transition">
      <user-time-stop
        @reFetchTimestops="getAllTimestops()"
        :user="user"
        :userTimestops="userTimestops"
        @close-view="timestopActive = false"></user-time-stop>
    </v-dialog>

    <v-dialog style="z-index: 9999" v-model="healthcareActive" persistent fullscreen transition="dialog-bottom-transition">
      <user-healthcare @close-view="healthcareActive = false"></user-healthcare>
    </v-dialog>

    <v-dialog v-model="showNoContractInfo" max-width="420" content-class="glass-dialog-wrapper">
      <v-card class="glass-dialog-card text-center pa-5">
        <div class="glow-effect"></div>

        <v-card-title class="justify-center flex-column pt-4 pb-2 relative z-index-2">
          <div class="icon-ring mb-5">
            <v-icon size="42" color="#FF9800">mdi-card-account-details-outline</v-icon>
          </div>
          <span class="text-h5 font-weight-black white--text text-shadow leading-tight"> Wo ist dein Abo? </span>
        </v-card-title>

        <v-card-text class="text-body-1 grey--text text--lighten-2 px-2 relative z-index-2">
          <p class="mb-5" style="font-size: 0.95rem">
            Du bist Mitglied, aber dein Abo wird hier nicht angezeigt? Keine Sorge, das ist meist nur eine Kleinigkeit.
          </p>

          <div class="info-box pa-4 rounded-xl mb-5 text-left">
            <div class="d-flex align-start">
              <v-icon color="#FF9800" class="mr-3 mt-1">mdi-alert-circle-outline</v-icon>
              <div class="caption white--text" style="line-height: 1.5; font-size: 0.85rem !important">
                <strong class="d-block mb-1 text-uppercase orange--text text--accent-2">Der Grund</strong>
                Unsere App und die Mitgliederverwaltung sind getrennt. Wenn deine E-Mail-Adresse hier anders ist als im Vertrag, finden wir dich nicht
                automatisch.
              </div>
            </div>
          </div>

          <p class="mb-1 white--text font-weight-bold">Die Lösung ist ganz einfach:</p>
          <p class="caption grey--text mb-0">
            Melde dich kurz beim <strong>Trainer-Team an der Theke</strong>. Wir gleichen die E-Mail-Adressen an und schon taucht dein Abo hier auf!
            🚀
          </p>
        </v-card-text>

        <v-card-actions class="justify-center pb-4 relative z-index-2">
          <v-btn rounded large block color="white" class="black--text font-weight-bold elevation-10 py-6" @click="showNoContractInfo = false">
            Alles klar, verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 
      <div>
        <v-card
        class="mx-4 mt-4 rounded-xl d-flex align-center pa-3 elevation-10"
        style="background: linear-gradient(45deg, #000, #1a4d23)"
        @click="showWrapped = true">
        <v-avatar color="white" size="48" class="mr-3">
          <span class="black--text font-weight-black">2025</span>
        </v-avatar>
        <div>
          <div class="white--text font-weight-bold">Dein Jahr 2025</div>
          <div class="green--text text--accent-3 caption">Jetzt ansehen &rarr;</div>
        </div>
      </v-card>
    </div>
    -->
  </div>
</template>

<script>
import api from "../api"
import { mapState, mapActions } from "vuex"
import userService from "../services/userService"

// Components Imports
import myTraining from "../components/training/myTraining_new.vue"
import diverseSlider from "../components/home/diverseSlider_new.vue"
import alibeyPopup from "@/views/aliBey/alibeyPopup.vue"
import PaymentHome from "./dashboard/payment/PaymentHome.vue"
import googleFeedbackDialog from "@/components/home/googleFeedbackDialog.vue"
import TowelReservation from "@/components/TowelReservation.vue"
import BlackWeekTeaser from "@/views/einmalig/BlackWeekTeaser.vue"
import TrainingZone from "@/components/home/TrainingZone.vue"

// Neue Karten Components
import membercard from "@/components/home/membercard_new.vue"
import ActiveContractCard from "@/components/home/ActiveContractCard.vue"
import EmployeeCard from "@/components/home/EmployeeCard.vue"

// Dialog Components
import UserTimeStop from "@/views/user/views/UserTimestop.vue"
import UserHealthcare from "@/views/user/views/UserHealthcare.vue"
import UpgradeContract from "@/views/dashboard/contract/components/upgradeContract_sebredesign.vue"

import HyroxReservation from "@/components/HyroxReservation.vue"
import ChatHomeTeaser from "@/components/home/chatHomeTeaser.vue"

import MiniStatsDashboard from "@/components/home/miniStatsDashboard.vue"
import LicensePlatePopup from "@/components/home/licensePlatePopup.vue"
export default {
  name: "Home",
  components: {
    LicensePlatePopup,
    googleFeedbackDialog,
    diverseSlider,
    TrainingZone,
    TowelReservation,
    alibeyPopup,
    myTraining,
    BlackWeekTeaser,
    PaymentHome,
    membercard,
    ActiveContractCard,
    EmployeeCard,
    UserTimeStop,
    UserHealthcare,
    UpgradeContract,
    HyroxReservation,
    ChatHomeTeaser,
    MiniStatsDashboard,
  },
  data() {
    return {
      showEmployeeCard: true,
      showNoContractInfo: false,
      userService,
      hideMyTraining: false,
      openPayments: false,
      //showParty: false,

      // Contracts Data
      hasActiveContracts: null,

      // Dialog Controls
      showContractDialog: false,
      timestopActive: false,
      healthcareActive: false,
      showNoContractInfo: false,

      preloadedPossibilities: null,
      initialSelectedPackage: null,
    }
  },
  watch: {
    user(newUser) {
      if (newUser?.consent1 && !this.navigationVisible) {
        this.toggleNavigationBarVisibility()
      }
    },
  },

  async created() {
    this.setSelectedNavigation("home")

    if (localStorage.getItem("token")) {
      if (!localStorage.getItem("pushToken") && window.flutter_inappwebview) {
        if (!localStorage.getItem("initPushCooldown")) {
          this.$emit("showPushPopUp")
        }
      }
      this.$emit("checkPopup")
      this.$emit("checkVersion")
      this.$emit("fetchNotifications")
      this.setNavigationBarText(null)
      this.setNewBottomNavigationUsage(null)
      // NACH dem Laden der grundlegenden Daten das Popup prüfen:
      setTimeout(() => {
        if (this.$refs.licensePopup && this.user && this.user.studio && this.user.studio.parkingAvailable) {
          this.$refs.licensePopup.checkAndShow()
        }
      }, 2000) // Leichter Delay, damit es nicht direkt beim Mounten aggressiv aufploppt
      /*
      let party = await api.fetchSignupAvailabilityParty()
      if (party.isEmployee && party.visible) {
        this.showParty = true
      }*/
    }

    // Lade Vertragsdaten
    this.getAllTimestops()
  },

  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),
    ...mapState("studioStore", ["selectedStudio"]),
    ...mapState("userStore", ["user"]),

    authenticated() {
      return !!localStorage.getItem("token")
    },
    alibeyStudio() {
      return this.user && this.user.studio_id === "alibey"
    },
    isStudioAccount() {
      console.log(this.user.email, this.user.studio.email, this.user.email === this.user.studio.email)
      return this.user.email === this.user.studio.email
    },
    buelachStudio() {
      return this.user && this.user.studio_id === "buelach"
    },

    // --- NEU: Prüft ob Membercard gültig ist (Zeit + Status) ---
    hasValidMembercard() {
      const mc = this.user?.membercard
      // 1. Grundlegende Checks
      if (!mc || !mc.isActive || !mc.endDate) return false

      // 2. Datums-Check: Ist endDate heute oder in Zukunft?
      // Wir nutzen $moment (Globale Vue Instanz)
      // 'day' Granularität sorgt dafür, dass die Karte bis zum Ende des Tages gültig bleibt
      return this.$moment().isSameOrBefore(this.$moment(mc.endDate), "day")
    },
  },

  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText", "setNewBottomNavigationUsage", "toggleNavigationBarVisibility"]),
    ...mapActions("navigationStore", ["setSelectedNavigation"]),
    upgradeCeated() {
      this.$toast.success("Dein Antrag wurde erfolgreich erstellt!")
    },
    openContractUpgrade(payload) {
      // Wenn die Karte uns schon Daten mitschickt, nutzen wir sie!
      if (payload && payload.possibilities) {
        this.preloadedPossibilities = payload.possibilities
      } else {
        this.preloadedPossibilities = null
      }
      this.initialSelectedPackage = null // Kein spezifisches Paket gewählt
      this.showContractDialog = true
    },

    // 2. Klick auf "Dazu buchen" Chip (Spezifisch)
    handleQuickUpgrade(payload) {
      // Payload enthält: { package, possibilities }
      this.preloadedPossibilities = payload.possibilities
      this.initialSelectedPackage = payload.package
      this.showContractDialog = true
    },

    closeContractDialog() {
      this.showContractDialog = false
      // Kurze Verzögerung beim Reset, damit die Animation nicht ruckelt
      setTimeout(() => {
        this.preloadedPossibilities = null
        this.initialSelectedPackage = null
      }, 300)
    },
    async getAllTimestops() {
      try {
        this.userTimestops = await api.fetchAllTimestopsForUserEmail()
      } catch (e) {}
    },
    openContractUpgrade() {
      this.showContractDialog = true
    },
    openTimestop() {
      this.timestopActive = true
    },
    openHealthcare() {
      this.healthcareActive = true
    },

    // Helper für Contract Berechnung
    daysInTimeSpan(timeSpan) {
      const start = this.$moment(timeSpan.TimeSpan.Start, "YYYY-MM-DD")
      const end = this.$moment(timeSpan.TimeSpan.End, "YYYY-MM-DD")
      return end.diff(start, "days") + 1
    },
    bonusCalculatedFromMultipleTimespans(allTimeSpans, timeSpanDays) {
      const totalDays = allTimeSpans.reduce((total, timeSpan) => total + this.daysInTimeSpan(timeSpan), 0)
      return (
        Number(totalDays) === Number(timeSpanDays) || Number(totalDays) - 1 === Number(timeSpanDays) || Number(totalDays) + 1 === Number(timeSpanDays)
      )
    },
    // -----------------------------------

    pushToReferralRoute() {
      this.$router.push("/referral")
    },
  },
}
</script>

<style lang="scss" scoped>
.Home {
  max-width: 800px;
  margin: 0 auto;
}

/* --- GLASS DIALOG STYLES --- */

/* Wrapper unsichtbar machen, damit der Schatten nicht eckig ist */
::v-deep .glass-dialog-wrapper {
  box-shadow: none !important;
  overflow: visible !important;
}

.glass-dialog-card {
  background: rgba(20, 20, 20, 0.85) !important; /* Dunkle Basis */
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px); /* Für Safari */
  border: 1px solid rgba(255, 255, 255, 0.1); /* Subtiler weißer Rand */
  border-radius: 28px !important;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5) !important;
}

/* Orangefarbener Schein im Hintergrund */
.glow-effect {
  position: absolute;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
  width: 150%;
  height: 60%;
  background: radial-gradient(circle, rgba(255, 152, 0, 0.25) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
  filter: blur(30px);
}

.icon-ring {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  background: rgba(255, 152, 0, 0.1);
  border: 1px solid rgba(255, 152, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(255, 152, 0, 0.15);
  margin: 0 auto;
}

.info-box {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* Utils */
.z-index-2 {
  position: relative;
  z-index: 2;
}

.text-shadow {
  text-shadow: 0 4px 10px rgba(0, 0, 0, 0.8);
}

.leading-tight {
  line-height: 1.1;
}
.party-banner-wrapper {
  max-width: 800px;
  // Zentrieren falls nötig, aber mx-3 regelt das meiste
  margin-left: auto;
  margin-right: auto;
}

.party-banner {
  position: relative;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: 80px;

  &:active {
    transform: scale(0.98);
  }

  // Hover Effekt für Desktop
  &:hover {
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3) !important; // Grüner Schein
  }
}

.banner-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // Dunkler Verlauf wie bei Hyrox
  background: linear-gradient(135deg, #1a1a1a 0%, #051405 100%);
  z-index: 1;
}

// Der subtile Glitzer Effekt
.glitter-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0.15; // Sehr dezent
  // Ein Muster aus winzigen Punkten
  background-image: radial-gradient(white 1px, transparent 1px), radial-gradient(rgba(76, 175, 80, 0.8) 1px, transparent 1px);
  background-size: 30px 30px;
  background-position: 0 0, 15px 15px;
}

.banner-content {
  position: relative;
  z-index: 2; // Über dem Hintergrund und Glitzer
}

.icon-circle-party {
  width: 48px;
  height: 48px;
  // Sattes Grün
  background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 15px rgba(67, 160, 71, 0.4); // Grüner Glow

  // Kleiner Glanz auf dem Icon-Kreis
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.status-stripe-party {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: #00e676; // Helles Neongrün für den Streifen unten
  z-index: 2;
  box-shadow: 0 -1px 8px rgba(0, 230, 118, 0.5);
}
</style>
